export default "__VITE_ASSET__Cz9hd1nv__"